document.addEventListener("DOMContentLoaded", function () {
  const FADE_MS = 300;

  /**
   * @param {HTMLElement} trigger
   * @returns {HTMLElement | null}
   */
  function getModalForTrigger(trigger) {
    const attr = trigger.getAttribute("data-modal-target");
    if (attr) {
      const trimmed = attr.trim();
      const el =
        trimmed.startsWith("#") || trimmed.startsWith(".")
          ? document.querySelector(trimmed)
          : document.getElementById(trimmed);
      if (el && el.classList.contains("modal")) return el;
      return null;
    }

    const section = trigger.closest("section");
    const next = section && section.nextElementSibling;
    if (next && next.classList.contains("modal")) return next;
    return null;
  }

  /**
   * @param {HTMLElement} modal
   */
  function closeModal(modal) {
    const iframe = modal.querySelector("iframe");
    modal.classList.remove("active");
    window.setTimeout(function () {
      if (iframe) iframe.src = "";
    }, FADE_MS);
  }

  /**
   * @param {HTMLElement} modal
   * @param {string | null} videoUrl
   */
  function openModal(modal, videoUrl) {
    const iframe = modal.querySelector("iframe");
    if (!iframe) return;

    document.querySelectorAll(".modal.active").forEach(function (m) {
      if (m !== modal) closeModal(m);
    });

    iframe.src = videoUrl || "";
    modal.classList.add("active");
  }

  document.querySelectorAll(".openVideo").forEach(function (button) {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      const modal = getModalForTrigger(this);
      if (!modal) return;
      const videoID = this.getAttribute("data-video");
      openModal(modal, videoID);
    });
  });

  document.querySelectorAll(".modal").forEach(function (modal) {
    const closeBtn = modal.querySelector(".close");
    if (closeBtn) {
      closeBtn.addEventListener("click", function () {
        closeModal(modal);
      });
    }

    modal.addEventListener("click", function (e) {
      if (!modal.classList.contains("active")) return;
      const iframe = modal.querySelector("iframe");
      const t = e.target;
      if (
        iframe &&
        t instanceof Node &&
        (t === iframe || iframe.contains(t))
      ) {
        return;
      }
      closeModal(modal);
    });
  });
});
